import bwv846Card from '@Assets/demo/bwv846/system_0.png';
import chopinOp9n2Card from '@Assets/demo/chopin-op9n2/system_0.png';

import { getSamplePageMeta } from '../seo/publicPageMeta';

/** Homepage tiles. Kept separate from `sampleProjects` so Home only
 *  downloads the first-system thumbnails, not every page image. */
export interface SampleCard {
  slug: string;
  cardTitle: string;
  composer: string;
  cardSrc: string;
}

export const SAMPLE_CARDS: SampleCard[] = [
  {
    slug: 'bach-prelude-in-c-major-bwv-846',
    cardTitle: 'Prelude in C major',
    composer: 'J. S. Bach',
    cardSrc: bwv846Card,
  },
  {
    slug: 'chopin-nocturne-op-9-no-2',
    cardTitle: 'Nocturne Op. 9 No. 2',
    composer: 'F. Chopin',
    cardSrc: chopinOp9n2Card,
  },
];

for (const card of SAMPLE_CARDS) {
  if (!getSamplePageMeta(card.slug)) {
    throw new Error(`publicPageMeta.json is missing /sample/${card.slug}`);
  }
}
